///
/// EarthBrowser
///
/// Hurricane Browser Feature
///
/// Manages hurricane browser window lifecycle and command palette registration
///
/// Created by Matt Giger on 9/5/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useEffect } from 'react'
import { Wind } from 'lucide-react'
import { HurricaneBrowserRenderer } from '@/components/features/hurricane-browser/HurricaneBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const HURRICANE_WINDOW_ID = 'hurricane-browser'
const HURRICANE_WINDOW_WIDTH = 780
const HURRICANE_WINDOW_HEIGHT = 500

export function HurricaneBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const hurricaneWindow = datasetWindows[HURRICANE_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'hurricane-browser',
			command: {
				id: 'hurricanes',
				title: 'Hurricanes',
				icon: <Wind className="w-4 h-4 text-sky-400" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						HURRICANE_WINDOW_ID,
						{
							id: HURRICANE_WINDOW_ID,
							title: 'Hurricanes',
							windowType: 'hurricane',
							x: 100,
							y: 100,
							width: HURRICANE_WINDOW_WIDTH,
							height: HURRICANE_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!hurricaneWindow) {
		return null
	}

	return (
		<HurricaneBrowserRenderer
			windowId={HURRICANE_WINDOW_ID}
			windowState={hurricaneWindow}
		/>
	)
}
